import { oddRowBackground } from "reports/constants/colors";
import styled from "styled-components/macro";

const tableHeaderBackground = "#182E58";

export const SummaryTableStyles = styled.div`
  .tableTitle {
    font-family: "Open Sans SemiBold";
    text-align: center;
    font-size: 20px;
    padding: 1em;
  }

  &&& {
    .MuiTable-root {
      line-height: 0em;
      font-family: "Heebo";
      width: 100%;
      margin-top: 50px;
    }
    .MuiTableHead-root {
      background-color: ${tableHeaderBackground};
    }
    .MuiTableCell-root {
      line-height: 0em;
      font-size: 0em;
      font-weight: none;
    }
    .MuiTableCell-head {
      color: white;
      font-weight: 500;
      font-size: 14px;
    }
    .MuiTableCell-body {
      font-weight: 400;
      font-size: 14px;
    }
    table tr:first-child {
      th:first-child {
        border-top-left-radius: 4px;
      }
      th:last-child {
        border-top-right-radius: 4px;
      }
    }
    .oddRow {
      background-color: ${oddRowBackground};
    }
    .subRow {
      border-top-style: hidden !important;
    }
    .subRowCell {
      font-weight: 300;
      font-size: 12px;
    }
    .numeric {
      text-align: right;
    }
  }
`;
